import React from "react";
import { ClipLoader } from "react-spinners";
import { IoIosWarning } from "react-icons/io";

const InfoCard = ({ title, value, icon, bgColor = "white", loading = false, error }) => {
  return (
    <div
      className="flex flex-col items-center px-5 min-h-[80px] 2xl:h-[12vh] bg-white rounded-lg "
      style={{
        boxShadow: "0px 8px 32px 0px rgba(51, 37, 174, 0.08)",
      }}
    >
      <div className="flex-grow w-full pt-4">
        <p className="text-sm  text-[#8E95A9] font-inter leading-[22px] font-medium">
          {title}
        </p>
      </div>

      <div className="flex flex-row pb-4 w-full justify-between">
        <h2 className="text-[24px]  font-semibold text-secondary leading-[40px] ">
          {loading ? 
            <ClipLoader color="#60a5fa" loading={loading} size={24} speedMultiplier={0.5}/>
            : error || !value ? 
            <IoIosWarning style={{ paddingTop: "0.2rem", color: "#D3D9DF" }} />
            :
            value
          }
        </h2>

        <img src={icon} alt={`${title} icon`} className="w-20 h-auto" />
      </div>
    </div>
  );
};

export default InfoCard;

// const InfoCardu= ({}) => {
//   return (
//     <div
//       className="flex flex-col items-center px-5 min-h-[80px] 2xl:h-[12vh] bg-white rounded-lg "
//       style={{
//         boxShadow: "0px 8px 32px 0px rgba(51, 37, 174, 0.08)",
//       }}
//     >
//       <div className="flex-grow w-full pt-4">
//         <p className="text-sm  text-[#8E95A9] font-inter leading-[22px] font-medium">
//           {title}
//         </p>
//       </div>

//       <div className="flex flex-row pb-4 w-full justify-between">
//         <h2 className="text-[24px]  font-semibold text-secondary leading-[40px] ">
//           {loading ? 
//             <ClipLoader color="#60a5fa" loading={loading} size={24} speedMultiplier={0.5}/>
//             : error ? 
//             <IoIosWarning style={{ paddingTop: "0.2rem", color: "#D3D9DF" }} />
//             :
//             value
//           }
//         </h2>
//         <div
//           className="flex items-center justify-center w-10 h-10  rounded-[12px]"
//           style={{ backgroundColor: bgColor }}
//         >
//           <img src={icon} alt={`${title} icon`} className="w-6 h-6 " />
//         </div>
//       </div>
//     </div>
//   );
// };
